import React from 'react';
import { FavoriteButton, Layout, SiteNav } from '@vwfs-bronson/bronson-react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getFavouriteCompanyId,
  getSelectedOutlet,
  saveSelectedOutlet,
  setFavouriteCompanyId,
} from '../../services/redux/features/outlet.slice';
import { getOutletDisplayText } from './utils';

type Props = {
  company: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData;
};

export const CompanyListItemForNavDropdown: React.FC<Props> = ({ company }) => {
  const dropdownText = getOutletDisplayText(company);
  const selectedOutlet = useSelector(getSelectedOutlet);
  const favouriteCompanyId = useSelector(getFavouriteCompanyId);
  const companyIsSelected = company.milesCompanyId === selectedOutlet?.milesCompanyId;
  const companyIsFavourite = favouriteCompanyId === company.milesCompanyId;
  const dispatch = useDispatch();

  return (
    <Layout middle center className="u-p-xsmall">
      <Layout.Item default="3/4">
        <SiteNav.Item.DropdownItem
          className="u-text-wrap u-mb-none"
          active={companyIsSelected}
          href=""
          onClick={(e) => {
            e.preventDefault();
            dispatch(saveSelectedOutlet(company));
          }}
        >
          {dropdownText}
        </SiteNav.Item.DropdownItem>
      </Layout.Item>

      <Layout.Item default="1/4">
        <FavoriteButton
          style={{ '--fav-button-color': '#FFFFFF' } as any}
          active={companyIsFavourite}
          iconOnly
          onPressedChange={() => {
            if (companyIsFavourite) {
              dispatch(setFavouriteCompanyId(undefined));
            } else {
              dispatch(setFavouriteCompanyId(company.milesCompanyId));
            }
          }}
        />
      </Layout.Item>
    </Layout>
  );
};
